import ApiClient from '../ApiClient';

class CaptainVoices extends ApiClient {
  constructor() {
    super('captain/voices', { accountScoped: true });
  }
}

export default new CaptainVoices();
